import React, { useState, useEffect } from "react";
import "./clients.css";
import axios from "axios";
import Moment from "react-moment";
import { Fragment } from "react";
import { MdArrowRight } from "react-icons/md";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import {
  combineDateTime,
  convertToTimeZone,
  formatDate,
  getFullName,
  getMondayDate,
  getMonthAgoDate,
} from "../../utils/CommonFunctions";
import { sortByDateDescend } from "../../Apis/commonApis";
import { currentCareSiteId } from "../../redux-toolkit/reducer/switchSites";
import { useSelector } from "react-redux";
import JournalDetailFacility from "./JournalDetailFacility";
import JournalDetailAgency from "./JournalDetailAgency";
import { useLocation } from "react-router-dom";

const ClientJournalAsApp = (props) => {
  let today = new Date();
  let monthAgoDate = getMonthAgoDate();
  const location = useLocation();
  const { clientId } = props;

  // let params = useParams();
  const { currentCareSiteData } = useSelector(
    (state) => state.caresiteDataReducer
  );

  const [journalData, setJournalData] = useState([]);
  const [clientJournal, setClientJournal] = useState({});
  const [loading, setLoading] = useState(false);

  const [filterType, setFilterType] = useState("custom");
  const [dateRange, setDateRange] = useState([monthAgoDate, new Date()]);
  const [startDate, endDate] = dateRange;

  useEffect(() => {
    if (currentCareSiteData) {
      if (filterType === "custom" && endDate) {
        getJournalbyClientId(formatDate(startDate), formatDate(endDate));
      } else if (filterType === "week") {
        const mondayDate = getMondayDate(new Date());
        getJournalbyClientId(formatDate(mondayDate), formatDate(new Date()));
      } else if (filterType === "today") {
        getJournalbyClientId(formatDate(new Date()), formatDate(new Date()));
      }
    }
  }, [filterType, dateRange, currentCareSiteData]);

  const getJournalbyClientId = (start, end) => {
    setLoading(true);
    axios({
      // url: `${process.env.REACT_APP_BASEURL}/journal?clientId=${clientId}`,
      url: `${process.env.REACT_APP_BASEURL}/journal?clientId=${clientId}&careHomeId=${currentCareSiteId}&startDate=${start}&endDate=${end}`,
      method: "GET",
      headers: { Authorization: localStorage.getItem("care_admin_token") },
    })
      .then((res) => {
        setLoading(false);
        const ClientData = res?.data?.result;
        if (ClientData.length > 0) {
          // if (currentCareSiteData?.carefacility === "facalities") {
          //   handleFacilityData(ClientData);
          // } else if (currentCareSiteData?.carefacility === "agency") {
          // }
          handleAgencyData(res?.data);
        } else {
          setJournalData([]);
          setClientJournal({});
        }
      })
      .catch((error) => console.log(`Error: ${error}`));
  };

  function handleAgencyData(allData) {
    const shiftData = allData?.result;
    const taskData = allData?.tasks;
    let clientJournals = [];
    // console.log(shiftData, "shiftData----");
    shiftData?.forEach((shift) => {
      if (shift) {
        const stateData = location?.state;
        const shiftTasks = taskData.filter(
          (item) => item.shiftDate?.split("T")[0] === shift.Date
        );
        const fandfRating = shift?.fanfRatings?.reduce(
          (acc, curr) => acc + curr.rating,
          0
        );
        const avgRating =
          shift?.fanfRatings?.length > 0
            ? fandfRating / shift?.fanfRatings?.length
            : 0;
        clientJournals.push({
          shiftId: shift?.shiftId,
          _id: shift?._id,
          Date: shift?.Date ?? "",
          shiftDateTime: combineDateTime(
            shift.Date,
            shift.startingTime,
            shift.timeZone
          ),
          endDate: shift?.endDate ?? "",
          Task: shiftTasks ?? [],
          notesData: shift.notesData,
          forClient: stateData?.name,
          clientImage: stateData?.image,
          startingTime: shift?.startingTime ?? "",
          endingTime: shift?.endingTime ?? "",
          shiftTimeZone: shift.timeZone,
          careTeamId: shift?.careTeamId,
          checkinDateTime: shift?.checkinDateTime,
          checkoutDateTime: shift?.checkoutDateTime,
          fndfRating: Math.ceil(avgRating),
          clientId: shift?.clientId,
          shiftApprovalstatus: shift?.shiftApprovalstatus ?? "",
          shiftEndDatetime: shift?.shiftEndDatetime ?? "",
          status: shift?.status ?? shift?.status,
          templateType: shift?.templateType ?? "",
          wellbeingAssessment: shift?.wellbeingAssessment ?? {},
        });
      }
    });

    if (clientJournals?.length > 0) {
      let sortedObj = sortByDateDescend(clientJournals, "shiftDateTime");
      let groupdate = groupJournalDataByDate(sortedObj);
      // let groupdate = groupItems(sortedObj, "Date");
      // groupdate = Object.entries(groupdate).map(([k, v]) => ({ [k]: v }));
      setJournalData(groupdate ?? []);
      setClientJournal(sortedObj[0] ?? {});
    } else {
      setJournalData([]);
      setClientJournal({});
    }
  }

  const calendarStrings = {
    lastDay: "[Yesterday ]",
    sameDay: "[Today ]",
    nextDay: "[Tomorrow ]",
    lastWeek: "L",
    nextWeek: "L",
    sameElse: "L",
  };

  function customDateChangeHandler(daterange) {
    setDateRange(daterange);
  }

  const activeTab = {
    background: "#f0e8f7",
  };

  return (
    <>
      <div className="row clientList">
        <div className="col-md-6 shiftsHistory">
          <h5 style={{ color: "#9B51E0" }}>Shifts History</h5>
          <ul className="filter_box me-2 mb-1">
            <button
              exact
              className={filterType === "today" ? "active" : ""}
              onClick={() => setFilterType("today")}
            >
              Today
            </button>
            <button
              className={filterType === "week" ? "active " : ""}
              onClick={() => setFilterType("week")}
            >
              This Week
            </button>
            <button
              className={filterType === "custom" ? "active" : ""}
              onClick={() => setFilterType("custom")}
            >
              Custom
            </button>
            {filterType === "custom" ? (
              <div className="datepicker_input">
                <DatePicker
                  selectsRange={true}
                  startDate={startDate}
                  endDate={endDate}
                  onChange={(update) => {
                    customDateChangeHandler(update);
                  }}
                  isClearable={true}
                />
              </div>
            ) : (
              <div className="container">&ensp;</div>
            )}
          </ul>
        </div>
        <div className="col-md-6"></div>
        <div className="col-md-6 journalListScroll">
          <ul className="menuList">
            {loading && <p>Loading...</p>}

            {journalData.length > 0 &&
              journalData?.map((journal) => {
                // const date = Object.keys(journal);
                // const datewisejournal = Object.values(journal).flatMap(
                //   (num) => num
                // );
                return (
                  <Fragment>
                    <h5 className="titlen">
                      <span style={{ color: "#BB6BD9" }}>
                        <Moment calendar={calendarStrings}>
                          {journal.date}
                        </Moment>
                      </span>{" "}
                      <br />
                      <Moment format="Do MMM YYYY">{journal.date}</Moment>
                    </h5>
                    {journal?.shifts?.map((item, index) => {
                      return (
                        <li
                          style={
                            item._id === clientJournal._id ? activeTab : {}
                          }
                          key={index}
                          onClick={() => {
                            setClientJournal(item);
                          }}
                        >
                          <a>
                            {/* <img alt="" src={item?.careTeamId[0]?.image} /> */}
                            <div className="body">
                              <p style={{ color: "#BB6BD9" }}>
                                {item?.startingTime} - {item?.endingTime}
                              </p>
                              <h5> Shift Summary</h5>
                              <MdArrowRight className="arrowIcon" />
                            </div>
                          </a>
                        </li>
                      );
                    })}
                  </Fragment>
                );
              })}
            {loading === false && journalData.length === 0 && (
              <p>No Shift Available</p>
            )}
          </ul>
        </div>
        {Object.keys(clientJournal).length !== 0 && (
          <>
            {/* {currentCareSiteData?.carefacility === "facalities" && (
              <JournalDetailFacility clientJournal={clientJournal} />
            )}
            {currentCareSiteData?.carefacility === "agency" && (
            )} */}
            <JournalDetailAgency
              clientJournal={clientJournal}
              clientId={clientId}
            />
          </>
        )}
      </div>
    </>
  );
};

export default ClientJournalAsApp;

function groupJournalDataByDate(shiftdata) {
  if (shiftdata.length < 1) {
    return [];
  }
  const grouped = {};
  shiftdata?.forEach((item) => {
    const dateLabel = new Date(item.Date).toDateString();

    if (!grouped[dateLabel]) {
      grouped[dateLabel] = [];
    }
    grouped[dateLabel].push(item);
  });

  return Object.keys(grouped).map((date) => ({
    date,
    shifts: grouped[date],
  }));
}
